export default __webpack_public_path__ + "assets/deliberato-component.0e420bbe.svg";